export default __webpack_public_path__ + "static/c573d55a31b08c5d3b61e2966e9f394d.png";